export default __webpack_public_path__ + "static/media/producto-25.7316c190.jpeg";